import { fetchOrder } from '@/entities/orders/thunks/fetchOrder'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

import { setDetailViewedOrderId } from '../slices/userInterfaceSlice'

type SetDetailViewedOrderPayload = {
  orderId: EntityId
}

export const setDetailViewedOrder = createAsyncThunk('userInterface/setDetailViewedOrder', async ({ orderId }: SetDetailViewedOrderPayload, { dispatch }) => {
  const result = await dispatch(fetchOrder({ orderId }))

  if (fetchOrder.fulfilled.match(result)) {
    dispatch(setDetailViewedOrderId(orderId))
  }
})
